module.exports = __webpack_public_path__ + "img/walk.8a4ebb12.png";